export function formatLineUpData(orchestraJson) {
  const formattedSections = [];

  Object.entries(orchestraJson).forEach(([sectionName, instruments]) => {
    const formattedInstruments = [];

    Object.entries(instruments).forEach(([instrumentName, players]) => {
      const lines = [];
      let currentLine = [];

      players.forEach((player, idx) => {
        // Utwórz skróconą nazwę lub NN
        let displayName;
        if (player.first_name === "NN" || player.last_name === "NN") {
          displayName = "NN";
        } else {
          const shortLast = player.last_name.substring(0, 3) + ".";
          displayName = `${player.first_name} ${shortLast}`;
        }

        // Sekcja STRING — tylko 2 muzyków w jednej linii
        if (sectionName === "String") {
          currentLine.push(displayName);
          if (currentLine.length === 2 || idx === players.length - 1) {
            lines.push(currentLine.join(" - "));
            currentLine = [];
          }
        } else {
          // Inne sekcje — wszyscy w jednej linii
          currentLine.push(displayName);
        }
      });

      if (sectionName !== "String" && currentLine.length > 0) {
        lines.push(currentLine.join(" - "));
      }

      formattedInstruments.push({
        name: instrumentName,
        lines
      });
    });

    formattedSections.push({
      section: sectionName,
      instruments: formattedInstruments
    });
  });

  return formattedSections;
}